module.exports = __webpack_public_path__ + "static/media/Arrowright.7cad4b8f.svg";